export default "__VITE_ASSET__VCM86xVH__"